export enum UploadStatus {
  Pending = 'pending',
  Uploading = 'uploading',
  Uploaded = 'uploaded',
  Failed = 'failed',
}
